module.exports = __webpack_public_path__ + "img/ring_r_c_0_0.8784c8a3.png";